export default __webpack_public_path__ + "static/media/d1.cf0ae941.png";